export enum MyEventsFilteringEnum {
	Upcoming = 'upcoming',
	Past = 'past',
}
